export default {
  referralFields: (leadSourceTypeClass, leadSourceClass, leadSourceManualClass) => [
    {
      type: 'select',
      label: 'How did you hear about us?',
      model: 'leadSourceType',
      required: true,
      selectOptions: {
        noneSelectedText: '-',
      },
      values: [
        { name: 'Referral', id: 'referral' },
        { name: 'Referral Partner', id: 'partner' },
        { name: 'Conferences', id: 'conferences' },
        { name: 'Social Media', id: 'social_media' },
        { name: 'Online Search', id: 'online_search' },
      ],
      styleClasses: leadSourceTypeClass || 'col-md-12',
      validator: 'string',
      onChanged(model) {
        /* eslint no-param-reassign: ["error", { "props": false }] */
        model.leadSource = null;
        model.leadSourceManual = null;
      },
    },
    {
      type: 'select',
      model: 'leadSource',
      required: true,
      selectOptions: {
        noneSelectedText: '-',
      },
      values: (model) => {
        switch (model.leadSourceType) {
          case 'referral':
            return [
              { name: 'Agent', id: 'agent' },
              { name: 'Broker', id: 'broker' },
              { name: 'Employee', id: 'employee' },
              { name: 'Existing Customer', id: 'customer' },
              { name: 'Unidentified Person / Entity', id: 'unidentified' },
            ];
          case 'partner':
            return [
              { name: 'CIX', id: 'cix' },
              { name: 'Private Lender Link', id: 'pll' },
            ];
          case 'conferences':
            return [
              { name: 'American Association of Private Lenders', id: 'aapl' },
              { name: 'California Mortgage Association (CMA)', id: 'cma' },
              { name: 'Homevestors', id: 'homevestors' },
              { name: 'RE Investment Club', id: 're' },
              { name: 'Nahrep', id: 'nahrep' },
              { name: 'National Association of Realtors', id: 'realtors' },
              { name: 'Pitbull Conference', id: 'pitbull' },
              { name: 'Realty411 CashFlow Expo', id: 'realty' },
              { name: 'San Diego Investors', id: 'sdi' },
              { name: 'Meetup', id: 'meetup' },
              { name: 'Other', id: 'other' },
            ];
          case 'social_media':
            return [
              { name: 'Facebook', id: 'facebook' },
              { name: 'Instagram', id: 'instagram' },
              { name: 'Linkedin', id: 'linkedin' },
              { name: 'Pinterest', id: 'pinterest' },
              { name: 'Twitter', id: 'twitter' },
              { name: 'Other', id: 'other' },
            ];
          default:
            return [];
        }
      },
      styleClasses: leadSourceClass || 'col-md-12',
      validator: 'string',
      onChanged(model) {
        /* eslint no-param-reassign: ["error", { "props": false }] */
        model.leadSourceManual = null;
      },
      visible(model) {
        return model.leadSourceType && model.leadSourceType !== 'online_search';
      },
    },
    {
      type: 'input',
      inputType: 'text',
      placeholder: 'Name',
      model: 'leadSourceManual',
      required: true,
      styleClasses: leadSourceManualClass || 'col-md-12',
      validator: 'string',
      visible(model) {
        return (
          (model.leadSource && model.leadSourceType) &&
          (
            (model.leadSourceType === 'referral' && model.leadSource !== 'unidentified') ||
            (
              model.leadSourceType === 'conferences' &&
              ['meetup', 'other'].includes(model.leadSource)
            ) ||
            (model.leadSourceType === 'social_media' && model.leadSource === 'other')
          )
        );
      },
    },
  ],
  propertyKnown: value => ['made_offer', 'signed_purchase_contract'].includes(value),
  propertyUnknown: value => ['looking_for_property', 'identified_property'].includes(value),
  transactionTypeRefinance: value => value === 'refinance',
};



// WEBPACK FOOTER //
// ./src/components/inquiry/libs/helper.js